<template>
  <div class="contact-container">
    <h2 class="contact-heading">Contact Me</h2>
    <div class="contact-section">
      <form
        action="https://getform.io/f/d25c15a4-217c-44cc-a345-470d535e62dc"
        method="POST"
      >
        <h3>Get In Touch</h3>
        <label for="name">Name:</label>
        <input type="text" name="name" id="name" required />
        <label for="email">Email:</label>
        <input type="email" name="email" id="email" required />
        <label for="message">Message:</label>
        <textarea name="message" id="message" rows="4"></textarea>
        <button class="send">Send</button>
      </form>
      <div class="social-links">
        <div class="linkedin">
          <font-awesome-icon
            icon="fa-brands fa-linkedin"
            size="xl"
            style="color: #ffffff"
          /><a
            href="https://www.linkedin.com/in/josue-o-tejada/"
            target="_blank"
            >Linkedin.com/in/josue-o-tejada</a
          >
        </div>
        <div class="github">
          <font-awesome-icon
            icon="fa-brands fa-github"
            size="xl"
            style="color: #ffffff"
          /><a href="https://github.com/Jdevv96" target="_blank"
            >Github.com/Jdevv96</a
          >
        </div>
        <div class="resume-pdf">
          <font-awesome-icon
            icon="fa-solid fa-file-pdf"
            style="color: #ffffff"
            size="xl"
          />
          <a
            class="resume"
            href="https://drive.google.com/uc?export=download&id=1DK9m_FEW_Rlw_EwAH8nzO93WjLI-OVxa"
            download
            target="_blank"
            >Download PDF Resume
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactSection",
};
</script>

<style>
.contact-container {
  height: 100vh;
  padding-top: 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas:
    ". heading ."
    ". form .";
  align-items: center;
  justify-content: center;
  justify-items: center;
}

.contact-heading {
  color: white;
  grid-area: heading;
  margin-top: 50px;
  letter-spacing: 1px;
  font-size: 3rem;
}

.contact-section {
  grid-area: form;
  flex-direction: column;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2c001e;
  border-radius: 10px;
  padding-bottom: 20px;
  margin-bottom: 10rem;
}

form {
  display: flex;
  flex-direction: column;
  padding: 2vw 4vw;
  width: 90%;
  max-width: 600px;
}

form h3 {
  color: white;
  font-weight: 800;
  margin-top: 0;
  margin-bottom: 20px;
  letter-spacing: 1px;
  font-size: 30px;
}

form input,
form textarea {
  border: 0;
  margin: 10px 0;
  padding: 20px;
  background: #f5f5f5;
  outline: none;
  font-size: 16px;
  border-radius: 10px;
}

form label {
  color: white;
  text-align: start;
  font-size: 20px;
}

form button {
  padding: 15px;
  background: #e95420;
  color: white;
  font-size: 18px;
  border: 0;
  cursor: pointer;
  width: 150px;
  margin: 20px auto 0;
  border-radius: 30px;
}

.social-links {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.social-links a {
  text-decoration: none;
  color: white;
  margin: 0 10px;
  font-size: 18px;
}

@media only screen and (max-width: 1000px) {
  .contact-heading {
    font-size: 2rem;
  }

  form h3 {
    font-size: 1.5rem;
  }

  form {
    width: 500px;
    border-radius: 10px;
    background-color: #2c001e;
  }

  form input,
  form textarea {
    margin: 1em 0;
    padding: 10px;
    font-size: 16px;
  }

  form label {
    font-size: 18px;
  }

  form button {
    padding: 10px;
    font-size: 18px;
    width: 100px;
  }

  .contact-section {
    background: transparent;
  }

  .social-links {
    margin-top: 4em;
    flex-direction: column;
    align-items: flex-start;
  }

  .social-links a {
    font-size: 1.2rem;
  }

  .linkedin {
    padding: 0;
  }

  .github {
    margin: 0;
    padding: 1.5em 0;
  }
}

@media only screen and (max-width: 600px) {
  .contact-container {
    height: 100%;
  }

  .contact-section {
    margin-bottom: 5em;
  }

  form {
    width: 300px;
  }

  form input,
  form textarea {
    font-size: 14px;
  }

  form label {
    font-size: 14px;
  }

  form button {
    font-size: 16px;
  }

  .social-links a {
    font-size: 0.75rem;
  }
}
</style>
